import { COLORS } from '@btime/constants'
import { appendIf } from '@btime/helpers'
import { prop } from 'ramda'
import { useIsOwner, useSessionPermission } from '@btime/react-session'
import { useMemo } from 'react'

import { useNavigation } from '../../../../../utils/contexts/NavigationContext'
import { useOpenSegmentModal } from '../../../../../utils/routes/modals/modalsActions'
import { useRemoveSegments } from '../../_requests/removeSegments'

export const useRowsActions = (item, ids) => {
  const isOwner = useIsOwner()
  const canEdit = useSessionPermission('editSegment')
  const canDelete = useSessionPermission('deleteSegment')
  const openDetailsModal = useOpenSegmentModal()

  const navigate = useNavigation()

  const [deleteItems, { loading }] = useRemoveSegments()

  const singleOptions = useMemo(
    () => [
      {
        value: 'seeDetails',
        icon: 'BsSearch',
        onClick: () => openDetailsModal(item)
      },

      ...appendIf(isOwner, {
        value: 'Logs',
        icon: 'RiTimeLine',
        onClick: () => navigate(`/logs?entitySegmentIds=${item.id}`),
        to: `/logs?entitySegmentIds=${item?.id}`
      }),

      ...appendIf(canEdit, {
        value: 'edit',
        icon: 'BsPencil',
        onClick: () => navigate(`/segmentations/${item.id}/edit`),
        to: `/segmentations/${prop('id', item)}/edit`
      }),

      ...appendIf(canDelete, {
        value: 'remove',
        color: COLORS.red,
        icon: 'BsTrash',
        onClick: () => deleteItems([item.id])
      })
    ],
    [item, canDelete, canEdit, deleteItems, navigate, openDetailsModal]
  )

  const multiOptions = useMemo(
    () => [
      ...appendIf(isOwner, {
        value: 'Logs',
        icon: 'RiTimeLine',
        onClick: () => navigate(`/logs?entitySegmentIds=${ids?.join(',')}`),
        to: `/logs?entitySegmentIds=${ids?.join(',')}`
      }),

      ...appendIf(canDelete, {
        value: 'remove',
        color: COLORS.red,
        icon: 'BsTrash',
        onClick: () => deleteItems(ids)
      })
    ],
    [ids, canDelete, deleteItems]
  )

  return [!ids || ids.length === 1 ? singleOptions : multiOptions, loading]
}
